export { default as DetailHeading } from './DetailHeading';
